import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100%;
  margin-top: 20px;

`;

export const ContainerAgreements = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  width: 80%;
`;
